<template>
  <div class="container text-center mt-3" style="height: 87%">
    <h1> Page Not Found </h1>
    <br>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
};
</script>